import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { LOCAL_STORAGE } from "@ng-toolkit/universal";
import { TranslateService } from "@ngx-translate/core";
import { Lightbox } from "ngx-lightbox";
import { AppComponent } from "src/app/app.component";
import { FormData, Person } from "src/app/models/formData";
import { CountCartService } from "src/app/services/count-cart.service";
import { FormDataService } from "src/app/services/form-data.service";
import { RestService } from "src/app/services/rest.service";
import { ServiceSEOService } from "src/app/services/service-seo.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
@Component({
  selector: "app-cart",
  templateUrl: "./cart.component.html",
  styleUrls: ["./cart.component.css"],
  providers: [NgbModalConfig, NgbModal],
})
export class CartComponent implements OnInit {
  node_static_url = environment.node_static_url;
  person: Person;
  mDataArrayPerson: any[];
  invoice_id = 0;
  total = 0;
  countTotal = 0;
  isEmptyCart = false;
  timeLeft = 0;
  interval: any;
  model: any;
  isCheckOut = false;
  proofileCol = false;

  @Input() formData: FormData;
  @ViewChild("bcelForm", { static: false }) testFormEl;
  mPaymentMethod: any[];
  selected_payment_method: string;
  selected_payment_active: string;
  selected_payment_method_text: string;
  _albumsPhoto = [];
  _albumsPassport = [];
  _albumsCover = [];
  _albumProoFile = [];

  data = {
    session_id: "",
    input_id: "",
    input_value: "",
  };

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private app: AppComponent,
    private router: Router,

    private rest: RestService,
    private formDataService: FormDataService,
    private countIncart: CountCartService,
    private seo: ServiceSEOService,
    private _lightbox: Lightbox,
    config: NgbModalConfig,
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private localStorage: any
  ) {
    this.seo.addMetaTags();
    config.backdrop = "static";
    config.keyboard = false;
  }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.person = this.formDataService.getFormData();
    let authInfo: any = null;
    try {
      const localAuth = localStorage.getItem(environment.localAuthenInfo);
      if (localAuth && localAuth !== "null" && localAuth !== "undefined") {
        authInfo = JSON.parse(localAuth);
      }
    } catch (e) {
      console.warn("Failed to parse localAuthenInfo in cart:", e);
    }
    if (authInfo && authInfo.token) {
      this.person.token = authInfo.token;
      this.getData();
      this.selected_payment_method = "";
      this.selected_payment_method_text = "";
      this.selected_payment_active = "";
    } else {
      this.router.navigate(["/apply"]);
    }
  }
  getData() {
    this.person.currentActiveForm = "3";
    this.countIncart.funcCountCart();
    this.getPersonInfo();
  }
  addMorePerson() {
    this.formData = this.formDataService.resetFormData();
    this.router.navigate(["/application"]);
    this.data.session_id = this.localStorage.getItem("session_id");
    this.data.input_id = "addMorePeople";
    this.data.input_value = "add_more_people";

    // this.rest.updateUserSession(this.data).subscribe((res) => {
    //   console.log("Result Update Session when focus input:", res);
    // });
  }

  getPaymentMethods() {
    this.rest.getPaymentMethods().subscribe((result) => {
      this.mPaymentMethod = result;
    });
  }
  calculateTotal() {
    this.countTotal = this.mDataArrayPerson.length;
  }
  testPay() {
    const payment = {
      invoice_id: 3155,
      payment_method: "cbs",
      pay_from: null,
    };
    console.log({ payment });
  }

  proceedContinue(e: any) {
    this.data.session_id = this.localStorage.getItem("session_id");
    this.data.input_id = e.target.id;
    this.data.input_value = "to_payment_review";

    // this.rest.updateUserSession(this.data).subscribe((res) => {
    //   console.log("Result Update Session when focus input:", res);
    // });

    this.router.navigate(["/continue-review"]);
  }

  deletePerson(index: number, application_id, first_name) {
    this.data.session_id = this.localStorage.getItem("session_id");
    this.data.input_id = "deletePerson";
    this.data.input_value = "delete_person";

    // this.rest.updateUserSession(this.data).subscribe((res) => {
    //   console.log("Result Update Session when focus input:", res);
    // });

    Swal.fire({
      title: "Are you sure?",
      text: `Are you sure to remove ${first_name} ?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      cancelButtonText: "Cancel",
      confirmButtonText: "Remove",
    }).then((result) => {
      if (result.value) {
        this.rest.deletePerson(application_id).subscribe((rs) => {
          if (rs.status == "error") {
            this.isCheckOut = true;
            this.getPersonInfo();
            this.countIncart.funcCountCart();
            return Swal.fire({
              type: "error",
              title: `${rs.message}`,
              showConfirmButton: true,
            });
          } else {
            this.calculateTotal();
            this._albumsPhoto.splice(index, 1);
            this._albumsPassport.splice(index, 1);
            if (rs.status == "success") {
              this.getPersonInfo();
              this.countIncart.funcCountCart();
            }
          }
        });
      }
    });
  }

  open(content) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.startTimer();
    this.modalService.open(content, { centered: true });
  }
  openPhoto(index: number): void {
    if (isPlatformBrowser(this.platformId)) {
      this._lightbox.open(this._albumsPhoto, index, { centerVertically: true });
    }
  }
  openPassport(index: number): void {
    if (isPlatformBrowser(this.platformId)) {
      this._lightbox.open(this._albumsPassport, index, {
        centerVertically: true,
      });
    }
  }
  openProoFile(idx: number): void {
    console.log(idx);
    if (isPlatformBrowser(this.platformId)) {
      this._lightbox.open(this._albumProoFile, idx, {
        centerVertically: true,
      });
    }
  }
  openCover(index: number): void {
    if (isPlatformBrowser(this.platformId)) {
      this._lightbox.open(this._albumsCover, index, { centerVertically: true });
    }
  }
  closeImgPreview(): void {
    this._lightbox.close();
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.timeLeft += 20;
      if (this.timeLeft === 100) {
        clearInterval(this.interval);
        this.modalService.dismissAll();
        this.getPersonInfo();
        this.countIncart.funcCountCart();
      }
    }, 1000);
  }

  getPersonInfo() {
    this.rest.getPersonForPayment().subscribe((result) => {
      if (result.length > 0) {
        this.mDataArrayPerson = result;
        this.calculateTotal();
        this.invoice_id = result[0].invoice_id;
        let m_total = 0;
        for (let i = 0; i < result.length; i++) {
          m_total += result[i].price;
        }
        this.total = Math.round(m_total * 100) / 100 || 0;
      } else {
        this.mDataArrayPerson = result;
        this.isEmptyCart = true;
        this.total = 0;
      }
      this.onLoadImage(result);
    });
  }

  onLoadImage(person: Array<any>) {
    for (let i = 0; i < person.length; i++) {
      if (person[i].version == "2") {
        this.rest.getBase64ImageService(person[i].photo_name, "photo").subscribe((result) => {
          this._albumsPhoto.push({
            src: result["photo_name"],
            caption: "Photo "
          });
          this.mDataArrayPerson[i].photo_name = result["photo_name"];
        })
        this.rest.getBase64ImageService(person[i].passport_name, "passport").subscribe((result) => {
          this._albumsPassport.push({
            src: result["passport_name"],
            caption: "Passport "
          });
          this.mDataArrayPerson[i].passport_name = result["passport_name"];
        })
      } else {
        this.mDataArrayPerson[i].photo_name = person[i].photo_name;
        this._albumsPhoto.push({
          src: person[i].photo_name,
          caption: "Photo "
        });
        this.mDataArrayPerson[i].passport_name = person[i].passport_name;
        this._albumsPassport.push({
          src: person[i].passport_name,
          caption: "Passport "
        });
      }
    }
  }
}
